import React from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import "../styles/admin/sideBar.css";

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) =>
    location.pathname === path || location.pathname.startsWith(path + "/");

  const items = [
    { path: "/admin", icon: "fa-chart-line", label: "Estadísticas" },
    { path: "/admin/aseguradoras", icon: "fa-shield-halved", label: "Aseguradoras" },
    { path: "/admin/corredorPublico", icon: "fa-user-tie", label: "Corredores" },
    { path: "/admin/puertos", icon: "fa-anchor", label: "Puertos" },
    { path: "/admin/aduanas", icon: "fa-building-columns", label: "Aduanas" },
    { path: "/admin/transportistas", icon: "fa-truck", label: "Transportistas" },
    { path: "/admin/empresas", icon: "fa-briefcase", label: "Empresas" },
    { path: "/admin/solicitudes", icon: "fa-clipboard-list", label: "Solicitudes"},
    { path: "/admin/servicios", icon: "fa-screwdriver-wrench", label: "Servicios"},
    { path: "/admin/agenteAduanal", icon: "fa-id-badge", label: "Agentes Aduanales"},
    { path: "/admin/agenteNaviero", icon: "fa-ship", label: "Agentes Navieros"},
    { path: "/admin/rutas", icon: "fa-route", label: "Rutas"},
    { path: "/admin/estaciones", icon: "fa-train", label: "Estaciones Ferroviarias"},
    { path: "/admin/banner", icon: "fa-image", label: "Banner Principal"}
  ];

  return (
    <aside className="sidebar" aria-label="Barra lateral">
      <div className="sidebar-title">Seelogis Panel de administración</div>

      <nav className="menu" aria-label="Menú principal">
        {items.map(({ path, icon, label }) => (
          <Link
            key={path}
            to={path}
            className={`menu-item ${isActive(path) ? "active" : ""}`}
          >
           
            <i className={`fas ${icon} menu-icon`}></i>
            
            <span>{label}</span>
          </Link>
        ))}
      </nav>

      <div className="sidebar-spacer" />

      <button
        className="logout"
        onClick={() => {
          console.log("Cerrar sesión");
          navigate("/login");
        }}
      >
     
        <i className="fas fa-right-from-bracket logout-ic"></i>
        <span>Cerrar Sesión</span>
      </button>
    </aside>
  );
};

export default Sidebar;